import IntroWizardsCover from '@/components/intro-wizards/intro-wizards-cover/intro-wizards-cover';
import { Text } from '@cmpsr/components';

type IntroWizardCoverProps = {
  onNextButtonClick: () => void;
  onBackButtonClick: () => void;
};

export default function IntroWizardCover(props: IntroWizardCoverProps) {
  return (
    <IntroWizardsCover
      titleNode={
        <Text as="h1" variant="text-header-XL" color="text-light">
          <Text as="span" textStyle="text-header-xl-v" color="text-light !important">
            Congratulations!
          </Text>{' '}
          Reducing your cancer risk starts here.
        </Text>
      }
      descriptionNode={
        <Text variant={{ base: 'text-body-meta-regular', lg: 'text-body-regular' }} color="text-light">
          Welcome to your Catch Risk Assessment, the first step to taking control of your cancer risk. Your responses
          will enable the Catch biostatistical cancer model to calculate your baseline risk for 21 top cancers based on
          hundreds of lifestyle, environmental, and genetic risk factors - and generate an optimal Testing Protocol and
          personalized Action Plan based on your risk.
        </Text>
      }
      icon="congrats-nobg-05"
      onNextButtonClick={props.onNextButtonClick}
      onBackButtonClick={props.onBackButtonClick}
    />
  );
}
